module.exports = __webpack_public_path__ + "img/34491fee89cbdecd3670436100144af4.8e6ef8e4.png";